import { NGET, NPOST } from '@/utils/net-work'
import axios from 'axios'

// 获取中考试卷类型和年份
function getMiddleExam(params) {
  return NGET('/api/mh_exam/middle', params)
}

// 获取中考地区和学科
function getMiddleAreaAndSubjects(params: { paper_type: number; year: number }) {
  return NPOST('/api/mh_exam/middle/display', params)
}

// 获取中考试卷类型和年份
function getHigherExam(params) {
  return NGET('/api/mh_exam/higher', params)
}

// 获取中考地区和学科
function getHigherAreaAndSubjects(params: { paper_type: number; year: number }) {
  return NPOST('/api/mh_exam/higher/display', params)
}

// 获取试卷列表
function getPapers(params: { paper_ids?: number[]; is_assembly?: number }) {
  return NPOST('/api/mh_exam/paper-query', params)
}

function paperDoc(params: any) {
  return NPOST('/api/paper/doc', params)
}

function getSourceAddress(task_id: string | number) {
  return axios.get(`/api/paper/query/download/${task_id}`, {})
}

// 获取汇编题目
function getAssemblySubjects(params: { assembly_type: string }) {
  return NPOST('/api/mh_exam/middle/assembly-display', params)
}

export {
  getMiddleExam,
  getMiddleAreaAndSubjects,
  getHigherExam,
  getHigherAreaAndSubjects,
  getPapers,
  paperDoc,
  getSourceAddress,
  getAssemblySubjects
}
